import { Controller } from 'stimulus';
import gsap from 'gsap';
import toArray from '../helpers/toArray';
import csrfToken from '../helpers/csrfToken';
import dataLayer from '../tracking/dataLayer';

const columnForIndex = (index) => index % 5;
const rowForIndex = (index) => Math.floor(index / 5);

class AdventPage extends Controller {
  connect() {
    this.planets = toArray(this.element.querySelectorAll('.js-advent-planet'));

    setTimeout(this.transitionPageItems.bind(this), 500);
  }

  onDayClick(event) {
    const { currentTarget } = event;

    const label = currentTarget.textContent && typeof currentTarget.textContent === 'string'
      ? currentTarget.textContent.replace(/\s/g, '')
      : null;

    dataLayer.event('Advent item', 'open', label);

    this.loadContent(
      currentTarget.getAttribute('data-api-url'),
      currentTarget.getAttribute('data-advent-parameters'),
    );
  }

  // eslint-disable-next-line class-methods-use-this
  loadContent(apiUrl, parameters) {
    const contentHolder = document.getElementById('advent-modal').querySelector('.js-content');
    const loaderElement = document.getElementById('advent-modal').querySelector('.js-content-loader');

    contentHolder.innerHTML = '';

    gsap.set(loaderElement, {
      opacity: 1,
      display: 'block',
    });

    gsap.set(contentHolder, {
      opacity: 0,
    });

    fetch(`${apiUrl}${parameters}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': csrfToken(),
      },
    })
      .then((res) => res.text())
      .then((res) => {
        return gsap.to(loaderElement, {
          opacity: 0,
          onComplete: () => {
            loaderElement.style.display = 'none';
          },
        }).then(() => {
          contentHolder.innerHTML = res;
        });
      })
      .then(
        gsap.to(contentHolder, {
          opacity: 1,
        }),
      );
  }

  transitionPageItems() {
    gsap.set([this.dayTargets], {
      opacity: 0,
    });

    gsap.to([this.headingTarget, this.calendarTarget, this.ballsTarget], {
      opacity: 1,
      duration: 1.2,
      ease: 'power1.out',
      stagger: 0.4,
    });

    gsap.fromTo(this.dayTargets, {
      x: (index) => {
        const column = columnForIndex(index);

        if (column >= 3) {
          return column === 3 ? 20 : 40;
        }

        if (column <= 1) {
          return column === 1 ? -20 : -40;
        }

        return 0;
      },
      y: (index) => {
        const row = rowForIndex(index);

        if (row >= 4) {
          return row === 4 ? 20 : 40;
        }

        if (row <= 1) {
          return row === 1 ? -20 : -40;
        }

        return 0;
      },
    }, {
      opacity: 1,
      x: 0,
      y: 0,
      delay: 0.5,
      duration: 1.2,
      ease: 'power1.out',
      stagger: {
        from: 'random',
        amount: 0.4,
      },
    });

    gsap.fromTo(this.lineTargets, {
      opacity: 0,
      y: (index) => ((index === 0) ? -30 : 30),
    }, {
      delay: 0.5,
      opacity: 1,
      y: 0,
      duration: 1.3,
      ease: 'power1.out',
      stagger: 0.5,
    });

    gsap.fromTo(this.planets, {
      scale: 0.8,
      opacity: 0,
    }, {
      opacity: 1,
      scale: 1,
      delay: 0.25,
      stagger: 0.3,
      duration: 1,
      ease: 'power1.out',
    });
  }
}

AdventPage.targets = [
  'heading',
  'calendar',
  'balls',
  'day',
  'line',
];

export default AdventPage;
